import axios from 'axios'
import {API_ENDPOINT} from '../../../config'

const getDefaultState = () => {
    return {
        loadingSaleReport: false,
        orderReport: [],
        criteria: {
            type: "daily",
            from: "",
            to: ""
        }
    }
}

const loadSaleReport = instance => {

    if(instance.state.criteria.from.length === 0 || instance.state.criteria.to.length === 0){
        alert("Please choose date range")
        return
    }

    instance.setState({ ...instance.state, loadingSaleReport: true })
    
    axios({
        method: 'post',
        url: API_ENDPOINT + "/order/report",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: {
            criteria: instance.state.criteria
        }
    }).then(response => handleLoadSaleReportResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                loadingSaleReport: false
            })
            alert(error)
        })
}

const handleLoadSaleReportResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingSaleReport: false,
                orderReport: response.data.data.orderReport
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            instance.setState({
                ...instance.state,
                loadingSaleReport: false
            })
            alert(response.data.message)
    }
}

const Service = instance => {
    return {
        loadSaleReport: () => loadSaleReport(instance),
        getDefaultState: () => getDefaultState(instance)
    }
}

export default Service